import { motion } from 'framer-motion'
import React, { useEffect, useRef } from 'react'
import x from '../../assets/icons/close.svg'

const ViewContact = ({ active, close, contact }) => {
  const popupref = useRef(null)
  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])
  return (
    <motion.div
      className=" fixed inset-0 bg-overlay/30 w-screen  z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className=" w-1/3 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <div className="w-full">
          <div className=" w-full px-8 py-5 flex flex-col gap-4 ">
            <div className="flex border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
              <div>Contact Form</div>
              <img src={x} onClick={close} className=" cursor-pointer" alt="" />
            </div>
            <div>
              <label> Full Name </label>
              <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                {contact.full_name}
              </div>
            </div>
            <div>
              <label>Email </label>
              <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                {contact.email}
              </div>
            </div>
            <div>
              <label>Message</label>
              <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                {contact.message}
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default ViewContact
